import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseServiceFacade, GenericApiCall } from '../../../common/store/types';
import { AppState } from '../types';
import { contractTerminationReasonActions } from './contract-termination-reason.actions';
import { contractTerminationReasonSelectors } from './contract-termination-reason.selector';
import { ContractTerminationReasonModel } from './types';

@Injectable()
export class ContractTerminationReasonService extends BaseServiceFacade {
  constructor(store: Store<AppState>) {
    super(store);
  }
  getById: GenericApiCall<ContractTerminationReasonModel, string> =
    this.genericApiCall(
      contractTerminationReasonActions.getById,
      contractTerminationReasonSelectors.getById,
      true,
    );
  createInstance: GenericApiCall<ContractTerminationReasonModel, void> =
    this.genericApiCall(
      contractTerminationReasonActions.createInstance,
      contractTerminationReasonSelectors.createInstance,
      true,
    );
  add: GenericApiCall<
    ContractTerminationReasonModel,
    ContractTerminationReasonModel
  > = this.genericApiCall(
    contractTerminationReasonActions.add,
    contractTerminationReasonSelectors.add,
    true,
  );
  update: GenericApiCall<
    ContractTerminationReasonModel,
    ContractTerminationReasonModel
  > = this.genericApiCall(
    contractTerminationReasonActions.update,
    contractTerminationReasonSelectors.update,
    true,
  );
}
